<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top v-if="$utilFront.withPermission($prm.UPDATE_WEB_SERVICE)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="get(item, 3)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top  v-if="$utilFront.withPermission($prm.DELETE_WEB_SERVICE)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogCancelation"
      v-if="dialogCancelation"
      persistent
      max-width="30%"
    >
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "WebServicesTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
  },
  data() {
    return {
      dialogCancelation: false,
      headers: [
        {
          text: "Id servicio web",
          value: "idWebService",
          sortable: false,
          align: "center",
        },
        {
          text: "Nombre",
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: "URL",
          value: "pathService",
          sortable: false,
          align: "center",
        },
        {
          text: "Clave de acceso",
          value: "accessKey",
          sortable: false,
          align: "center",
        },
        {
          text: "Método de envío",
          value: "httpMethod",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    checkCancel(item) {
      this.dialogCancelation = true;
      this.$swal({
        toast: true,
        title: "¿Estás seguro de eliminar este valor?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.dialogCancelation = false;
          this.deleteItem(item);
        } else {
          this.dialogCancelation = false;
        }
      });
    },
  },
};
</script>
